export default __webpack_public_path__ + "static/media/start.931e4810.jpg";